import React from 'react';
import { FiZap } from 'react-icons/fi';
import './ScanModeSwitch.scss';

interface LaserModePanelProps {
  /** True once a handheld scan has actually been received in this session. */
  detected?: boolean;
  /** One line naming what this screen wants, e.g. "Scan the rack label". */
  hint?: string;
}

/**
 * What fills the viewport in laser mode, in place of the camera preview.
 *
 * A trigger pull produces no picture, so the screen has to carry the whole affordance: that the
 * app is listening, that the trigger is the thing to press, and — once a scan has actually
 * landed — that the device and the app are talking to each other. Without that last part a
 * black rectangle is indistinguishable from a broken camera, which is exactly the confusion the
 * modes were introduced to end.
 */
const LaserModePanel = ({ detected = false, hint }: LaserModePanelProps) => (
  <div className="laser-mode" role="status" aria-live="polite">
    <div className="laser-mode__sweep" aria-hidden />
    <div className="laser-mode__body">
      <FiZap className="laser-mode__icon" aria-hidden />
      <strong className="laser-mode__title">Laser mode</strong>
      <span className="laser-mode__prompt">{hint || 'Pull the trigger to scan'}</span>
      <span
        className={`laser-mode__status${detected ? ' laser-mode__status--live' : ''}`}
      >
        {detected ? 'Handheld scanner connected' : 'Waiting for the first scan'}
      </span>
    </div>
  </div>
);

export default LaserModePanel;
